export default "__VITE_ASSET__CHXZMHv3__"